// export const basciUrl = 'https://api.ksaasapi.com'
// export const basciUrl = 'https://kswin.ksaasapi.com'
// export const basciUrl = 'https://api.jktksaas.com'
export const basciUrl = 'https://www.tksaasapi.com'